module.exports = __webpack_public_path__ + "img/chinesecompany162.bf608bdc.png";